/* AI Install VSL funnel (DK-1712) — tracking + qualifier + Calendly + video.
 *
 * Tracking contract (identical to the Next.js build):
 *   every event -> fbq(track|trackCustom, name, params, {eventID})     (pixel 918368497984983)
 *              -> POST {api}/track with the SAME event_id              (CAPI via relay)
 *   Lead      -> POST {api}/lead (stores the lead, sends CAPI Lead), then fbq Lead with eventID lead-<leadId>
 *   Schedule  -> on Calendly postMessage; event_id calendly-<scheduled_event_uuid>; server verifies with Calendly
 *
 * Consent: nothing reaches Meta (browser OR server) and Clarity doesn't load until Shopify's Customer
 * Privacy API says marketing (Meta) / analytics (Clarity) is allowed. Fail closed if the API is missing.
 * Leads are stored regardless (the visitor asked us to contact them); CAPI is skipped without consent.
 *
 * QA: ?meta_test=<code> -> server events go to Meta Test Events only; browser Lead/Schedule held back.
 */
(function () {
  'use strict';
  var B = document.body;
  var API = B.getAttribute('data-api');
  var PIXEL = B.getAttribute('data-pixel');
  var CALENDLY = B.getAttribute('data-calendly');
  var BOOKED = B.getAttribute('data-booked');
  var VIEW = B.getAttribute('data-view');
  var STANDARD = { PageView: 1, ViewContent: 1, Lead: 1, Schedule: 1 };

  // ---------- storage helpers ----------
  function sget(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function sset(s, k, v) { try { s.setItem(k, v); } catch (e) {} }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]+)')); return m ? decodeURIComponent(m[1]) : undefined; }
  var qs = new URLSearchParams(location.search);

  function testCode() {
    var q = qs.get('meta_test');
    if (q) sset(sessionStorage, 'dk_ai_install_meta_test', q);
    return sget(sessionStorage, 'dk_ai_install_meta_test') || '';
  }
  function leadId() {
    var id = sget(sessionStorage, 'dk_ai_install_lead');
    if (!id) { id = uuid(); sset(sessionStorage, 'dk_ai_install_lead', id); }
    return id;
  }

  // Last non-empty ad click wins; 30-day window. Not personal data; kept even without consent
  // so a booking can be attributed if the visitor accepts cookies later in the visit.
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  function attribution() {
    var stored = {};
    try { stored = JSON.parse(sget(localStorage, 'dk_ai_install_attr') || '{}'); } catch (e) {}
    if (stored.saved_at && Date.now() - stored.saved_at > 30 * 864e5) stored = {};
    var fresh = {}, any = false;
    ATTR_KEYS.forEach(function (k) { var v = qs.get(k); if (v) { fresh[k] = v.slice(0, 300); any = true; } });
    var next = any
      ? Object.assign(fresh, { landing_url: location.href.slice(0, 500), referrer: document.referrer.slice(0, 300), first_seen: stored.first_seen || new Date().toISOString(), saved_at: Date.now() })
      : Object.assign({}, stored, { first_seen: stored.first_seen || new Date().toISOString(), landing_url: stored.landing_url || location.href.slice(0, 500), referrer: stored.referrer || document.referrer.slice(0, 300), saved_at: stored.saved_at || Date.now() });
    sset(localStorage, 'dk_ai_install_attr', JSON.stringify(next));
    var out = Object.assign({}, next); delete out.saved_at; return out;
  }
  var ATTR = attribution();

  function fbc() {
    var c = cookie('_fbc');
    if (!c) { var id = qs.get('fbclid') || ATTR.fbclid; if (id) c = 'fb.1.' + Date.now() + '.' + id; }
    return c;
  }

  // ---------- consent (Shopify Customer Privacy API) ----------
  var consent = { marketing: false, analytics: false, known: false };
  var onGrant = [];
  function readConsent(cp) {
    try {
      consent.marketing = !!cp.marketingAllowed();
      consent.analytics = !!cp.analyticsProcessingAllowed();
      consent.known = true;
    } catch (e) {}
  }
  function whenConsented(fn) { if (consent.marketing) fn(); else onGrant.push(fn); }
  function flushGrants() { if (!consent.marketing) return; var q = onGrant.splice(0); q.forEach(function (f) { try { f(); } catch (e) {} }); }
  function initConsent(done) {
    var called = false;
    function finish() { if (!called) { called = true; done(); } }
    function withApi() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return finish();
      readConsent(cp);
      finish();
    }
    document.addEventListener('visitorConsentCollected', function (e) {
      var d = (e && e.detail) || {};
      consent.marketing = !!d.marketingAllowed;
      consent.analytics = !!d.analyticsAllowed;
      consent.known = true;
      if (consent.analytics) loadClarity();
      flushGrants();
    });
    if (window.Shopify && window.Shopify.customerPrivacy) return withApi();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) return finish(); withApi(); });
      setTimeout(finish, 4000); // fail closed: no tracking if the API never answers
    } else finish();
  }

  // ---------- Meta pixel ----------
  var pixelReady = false;
  function ensurePixel() {
    if (pixelReady) return;
    pixelReady = true;
    if (!window.fbq) {
      var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      var s = document.createElement('script'); s.async = true; s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(s);
    }
    // No automatic events (they carry no event_id and can't dedupe): no pushState PageView, no auto clicks.
    window.fbq.disablePushState = true;
    window.fbq('set', 'autoConfig', false, PIXEL);
    window.fbq('init', PIXEL);
  }

  function log(name, id, params, sent) {
    (window.__dkTrackLog = window.__dkTrackLog || []).push({ at: new Date().toISOString(), name: name, eventID: id, params: params, sentToPixel: sent, consent: consent.marketing });
  }

  function pixel(name, params, id) {
    if (!consent.marketing) { log(name, id, params, false); return; }
    ensurePixel();
    var guard = !!testCode() && (name === 'Lead' || name === 'Schedule');
    log(name, id, params, !guard);
    if (guard) return;
    window.fbq(STANDARD[name] ? 'track' : 'trackCustom', name, params, { eventID: id });
  }

  function post(path, payload) {
    var body = JSON.stringify(payload);
    var url = API + path;
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (e) {}
  }

  // Browser + server, same event_id. Only runs with marketing consent.
  function track(name, params, opts) {
    opts = opts || {};
    var id = opts.eventID || (name.toLowerCase() + '-' + uuid());
    if (!consent.marketing) { log(name, id, params, false); return id; }
    pixel(name, params, id);
    var pageUrl = location.href.split('#')[0].slice(0, 500);
    var started = Date.now();
    (function send() {
      var fbp = cookie('_fbp');
      if (!fbp && Date.now() - started < 2000 && !opts.now) return void setTimeout(send, 250);
      post('/track', Object.assign({
        event_name: name, event_id: id, custom_data: params, page_url: pageUrl,
        fbp: fbp, fbc: fbc(), lead_id: sget(sessionStorage, 'dk_ai_install_lead') || undefined,
        test_event_code: testCode() || undefined
      }, opts.extra || {}));
    })();
    return id;
  }

  // ---------- Clarity ----------
  // The store already loads Clarity (project wndal0e5gz) through the Microsoft Clarity Shopify app, so
  // we never inject a second copy. With analytics consent we only tag the session with the funnel step.
  function loadClarity() {
    if (!consent.analytics || typeof window.clarity !== 'function') return;
    try { window.clarity('set', 'funnel', 'ai-install-vsl'); window.clarity('set', 'funnel_step', VIEW); } catch (e) {}
  }

  // ---------- ViewContent (first play OR qualifier in view, once) ----------
  var vcSent = false, vcPending = null;
  function viewContent(trigger) {
    if (vcSent) return;
    vcSent = true;
    whenConsented(function () { track('ViewContent', { content_name: 'AI Install VSL', content_category: 'ai-install', trigger: trigger }); });
  }

  // ---------- video ----------
  function mountVideo(slot) {
    var tall = window.matchMedia('(max-width: 767px)').matches;
    var src = slot.getAttribute(tall ? 'data-src-tall' : 'data-src-wide');
    var poster = slot.getAttribute(tall ? 'data-poster-tall' : 'data-poster-wide');
    var id = slot.getAttribute('data-video-slot');
    if (tall) slot.classList.add('is-tall');
    var v = document.createElement('video');
    v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'metadata';
    v.crossOrigin = 'anonymous'; v.poster = poster; v.setAttribute('aria-label', slot.getAttribute('data-label') || '');
    v.src = src;
    // Captions are burned into the picture; the VTT is offered but off by default.
    var cap = slot.getAttribute('data-captions');
    if (cap) { var t = document.createElement('track'); t.kind = 'captions'; t.srclang = 'en'; t.label = 'English'; t.src = cap; v.appendChild(t); }
    slot.appendChild(v);
    var fired = {}, played = false;
    function progress() {
      if (!v.duration || !isFinite(v.duration)) return;
      var pct = v.currentTime / v.duration * 100;
      [25, 50, 75, 95].forEach(function (m) {
        if (pct >= m && !fired[m]) { fired[m] = true; track('VideoProgress' + m, { video: id, percent: m, orientation: tall ? '9x16' : '16x9' }); }
      });
    }
    v.addEventListener('timeupdate', progress);
    v.addEventListener('ended', progress);
    v.addEventListener('play', function () { if (!played) { played = true; if (id === 'video3-vsl') viewContent('video_play'); } });
  }

  // ---------- calculator ----------
  function mountCalc() {
    var input = document.getElementById('aii-halfday'), out = document.querySelector('[data-calc-out]');
    if (!input || !out) return;
    input.addEventListener('input', function () {
      var n = Number(String(input.value).replace(/[^0-9.]/g, ''));
      if (n > 0) out.innerHTML = 'Over 50 weeks that’s <strong>£' + Math.round(n * 50).toLocaleString('en-GB') + '</strong> a year, per person.';
      else out.textContent = 'Type your figure to see the yearly number.';
    });
  }

  // ---------- qualifier ----------
  var STAFF_LABEL = { 'just-me': 'Just me', '2-4': '2–4', '5-10': '5–10', '11+': '11+' };
  var ROLE_LABEL = { owner: 'Owner/director', manager: 'Manager', other: 'Other' };

  function calendlyUrl(a, id) {
    var u = new URL(CALENDLY);
    u.searchParams.set('embed_domain', location.host);
    u.searchParams.set('embed_type', 'Inline');
    u.searchParams.set('hide_gdpr_banner', '1');
    u.searchParams.set('name', a.name);
    u.searchParams.set('email', a.email);
    u.searchParams.set('a1', ('Payroll staff: ' + STAFF_LABEL[a.staff] + '. Role: ' + ROLE_LABEL[a.role] + ". What's eating the team's time: " + a.time_eater).slice(0, 900));
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (ATTR[k]) u.searchParams.set(k, ATTR[k]); });
    u.searchParams.set('salesforce_uuid', id); // joins the booking to our stored lead (fbclid/_fbc/_fbp)
    return u.toString();
  }

  function listenForBooking() {
    window.addEventListener('message', function (e) {
      if (e.origin !== 'https://calendly.com') return;
      var d = e.data || {};
      if (d.event !== 'calendly.event_scheduled') return;
      var evUri = (d.payload && d.payload.event && d.payload.event.uri) || '';
      var invUri = (d.payload && d.payload.invitee && d.payload.invitee.uri) || '';
      var m = evUri.match(/scheduled_events\/([0-9a-f-]{36})/i);
      if (!m) return;
      var uuidEv = m[1].toLowerCase();
      if (consent.marketing) track('Schedule', { content_name: 'AI Install audit call', funnel: 'ai-install-vsl' }, { eventID: 'calendly-' + uuidEv, now: true, extra: { calendly: { event_uri: evUri, invitee_uri: invUri } } });
      setTimeout(function () { location.assign(BOOKED + '?e=' + uuidEv); }, 900);
    });
  }

  function mountQualifier() {
    var form = document.querySelector('[data-q-form]');
    if (!form) return;
    var section = document.getElementById('qualify');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { viewContent('qualifier_in_view'); io.disconnect(); } }, { threshold: 0.25 });
      io.observe(section);
    }
    function val(n) { var el = form.elements[n]; if (!el) return ''; if (el.length && el[0] && el[0].type === 'radio') { for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value; return ''; } return String(el.value || '').trim(); }
    function setErr(k, msg) { var p = form.querySelector('[data-err="' + k + '"]'); if (p) p.textContent = msg || ''; }
    form.addEventListener('change', function (e) { if (e.target && e.target.name) setErr(e.target.name, ''); });
    form.addEventListener('input', function (e) { if (e.target && e.target.name) setErr(e.target.name, ''); });
    var btn = form.querySelector('[data-submit]'), serverErr = form.querySelector('[data-server-err]'), busy = false;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      var a = { staff: val('staff'), role: val('role'), invest: val('invest'), time_eater: val('time_eater'), name: val('name'), email: val('email'), consent: !!form.elements.consent.checked };
      var errs = {};
      if (!a.staff) errs.staff = 'Pick how many people are on your payroll.';
      if (!a.role) errs.role = 'Pick your role.';
      if (a.time_eater.length < 3) errs.time_eater = 'Tell me what’s eating your team’s time (a few words is fine).';
      if (!a.invest) errs.invest = 'Pick Yes or Not yet.';
      if (a.name.length < 2) errs.name = 'Add your name.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(a.email)) errs.email = 'Add a valid email address.';
      ['staff', 'role', 'time_eater', 'invest', 'name', 'email'].forEach(function (k) { setErr(k, errs[k]); });
      var keys = Object.keys(errs);
      if (keys.length) { var f = form.querySelector('[data-field="' + keys[0] + '"]'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }

      busy = true; btn.disabled = true; btn.textContent = 'Checking…'; serverErr.hidden = true;
      var id = leadId(), allowed = consent.marketing, eventID = allowed ? 'lead-' + id : 'nolead-' + uuid();
      var payload = Object.assign({}, a, {
        lead_id: id, event_id: eventID, tracking: allowed, company_website: form.elements.company_website.value || '',
        attribution: ATTR, fbp: allowed ? cookie('_fbp') : undefined, fbc: allowed ? fbc() : undefined,
        page_url: location.href.split('#')[0], test_event_code: testCode() || undefined
      });
      fetch(API + '/lead', { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { r: r, d: d }; }); })
        .then(function (x) {
          var d = x.d || {};
          if (!x.r.ok || !d.ok) {
            if (d.errors) Object.keys(d.errors).forEach(function (k) { setErr(k, d.errors[k]); });
            serverErr.textContent = d.error || (d.errors ? 'Please check the highlighted answers.' : 'Something went wrong. Please try again.');
            serverErr.hidden = false; busy = false; btn.disabled = false; btn.textContent = 'Show me available times';
            return;
          }
          if (allowed) pixel('Lead', { qualified: d.qualified ? 'true' : 'false', staff_band: a.staff, role: a.role, invest_60d: a.invest, content_name: 'AI Install VSL qualifier' }, eventID);
          document.querySelector('[data-q-form-wrap]').hidden = true;
          var target;
          if (d.qualified) {
            target = document.querySelector('[data-q-qualified]');
            var frame = document.createElement('iframe');
            frame.title = 'Book your free AI audit call';
            // Sandbox WITHOUT allow-top-navigation: the shared "ai-business-coach" event type redirects
            // bookers to /pages/ai-discovery-booked (used by the rest of the site). The sandbox stops that
            // redirect taking over this page, so listenForBooking() always sends them to BOOKED instead.
            frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-storage-access-by-user-activation');
            frame.src = calendlyUrl(a, id);
            document.querySelector('[data-cal]').appendChild(frame);
            listenForBooking();
          } else {
            target = document.querySelector('[data-q-nurture="' + (d.reason || 'not-yet') + '"]');
            if (a.consent) { var cl = target.querySelector('[data-consent-line]'); if (cl) cl.hidden = false; }
          }
          target.hidden = false;
          setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); target.focus({ preventScroll: true }); }, 50);
        })
        .catch(function () {
          serverErr.textContent = 'Couldn’t reach the server. Check your connection and try again.';
          serverErr.hidden = false; busy = false; btn.disabled = false; btn.textContent = 'Show me available times';
        });
    });
  }

  // ---------- boot ----------
  function boot() {
    document.querySelectorAll('[data-video-slot]').forEach(mountVideo);
    mountCalc();
    mountQualifier();
    initConsent(function () {
      if (consent.analytics) loadClarity();
      // PageView waits for marketing consent; if it comes later in the visit it fires then.
      onGrant.unshift(function () { track('PageView', { funnel_step: VIEW }); }); // PageView first
      flushGrants();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
